<template>
  <div class="derivatives-filters" data-testid="derivatives-filters">
    <div>
      <Heading :level="3">Derivativos</Heading>
    </div>
    <div class="derivatives-filters__content">
      <template v-if="isLoading">
        <div class="derivatives-filters__content__left">
          <HeaderSubtitleLoader />
        </div>
        <HeaderFilterLoader />
      </template>
      <template v-else>
        <div class="derivatives-filters__content__right">
          <FilterSelect
            v-if="hasTypeOptions"
            class="derivatives-filters__select"
            :options="typeOptions"
            :value="filters[DerivativesFiltersTypes.Type].selected || ''"
            label="Tipo"
            data-testid="derivatives-type-filter"
            use-option-label
            @change="
              filter =>
                handleEmitOnFilterChange(DerivativesFiltersTypes.Type, filter)
            "
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import {
  Heading,
  IFilterOption,
  FilterSelect
} from '@warrenbrasil/nebraska-web';
import {
  HeaderFilterLoader,
  HeaderSubtitleLoader
} from '@/modules/trade/views/TradePositionsView/components/Loaders';

import {
  DerivativesFiltersDateValues,
  DerivativesFiltersTypes,
  DerivativesFiltersTypeValues,
  IDerivativesFilters
} from '../../types';
import { StringFormatted } from '@/modules/trade/types';

interface Props {
  updatedAt?: string;
  isLoading?: boolean;
  filters: IDerivativesFilters;
}
type Emits = (
  event: 'on-filter-change',
  filterType: DerivativesFiltersTypes,
  filter?: DerivativesFiltersTypeValues | DerivativesFiltersDateValues
) => void;

const props = withDefaults(defineProps<Props>(), {
  updatedAt: undefined,
  isLoading: false
});
const emits = defineEmits<Emits>();

const typeOptions = computed(() =>
  props.filters[DerivativesFiltersTypes.Type].available.map(formatFilterOption)
);

const hasTypeOptions = computed(() => typeOptions.value.length > 0);

const formatFilterOption = (option: StringFormatted): IFilterOption => ({
  value: option.value,
  label: option.formatted
});

const handleEmitOnFilterChange = (
  filterKey: DerivativesFiltersTypes,
  filterValue?: DerivativesFiltersTypeValues | DerivativesFiltersDateValues
) => {
  emits('on-filter-change', filterKey, filterValue);
};
</script>
<style lang="less" scoped>
.derivatives-filters {
  &__content {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    &__left {
      display: flex;
      align-items: center;
      margin-top: @size-spacing-x300;
    }

    &__right {
      display: flex;
      align-items: center;
    }
  }

  &__filter-option {
    margin-right: @size-spacing-x300;
  }

  &__select {
    margin-left: @size-spacing-x300;
  }
}
</style>
